import { render } from "./CreationRead.vue?vue&type=template&id=3786ac14&scoped=true"
import script from "./CreationRead.vue?vue&type=script&lang=js"
export * from "./CreationRead.vue?vue&type=script&lang=js"

import "./CreationRead.vue?vue&type=style&index=0&id=3786ac14&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3786ac14"]])

export default __exports__